module.exports = __webpack_public_path__ + "static/media/wall2.f7cbbd0a.jpg";